import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <a href="#accueil" className="footer-logo">
          <span className="g-text">Geek AI</span>
        </a>
        <p className="footer-copy">© {new Date().getFullYear()} Geek AI – Tous droits réservés</p>
        <div className="footer-links">
          <a href="#services">Services</a>
          <a href="#processus">Méthode</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
    </footer>
  );
}
